var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-row', {
    staticClass: "row--sm"
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-select', _vm._b({
    on: {
      "input": _vm.onChangeType
    },
    model: {
      value: _vm.type,
      callback: function ($$v) {
        _vm.type = $$v;
      },
      expression: "type"
    }
  }, 'v-select', Object.assign({}, _vm.attrs_input2, {
    items: _vm.types,
    label: _vm.readonly ? '판매채널' : '판매채널 수수료율'
  }), false))], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "6"
    }
  }, [_c('v-currency-field', _vm._b({
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.commission,
      callback: function ($$v) {
        _vm.commission = $$v;
      },
      expression: "commission"
    }
  }, 'v-currency-field', Object.assign({}, _vm.attrs_input2, {
    decimalLength: {
      min: 0,
      max: 2
    },
    readonly: _vm.readonly,
    label: _vm.readonly ? '수수료율' : '직력입력',
    suffix: _vm.commission ? '%' : undefined
  }), false))], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }